import service from '@/utils/server';

const modName='/md/soldTo/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName+'pageInfo',
    method: 'post',
    data
  })
};
//导出文件方法
export const getExportData = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};
//导入
export const upload = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'upload',
    method: 'post',
    data
  });
};

//模板下载
export const downLoadSoldToTemplate = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};
//编辑详情
export const detailInfo = data => {
  return service({
    url: modName + 'edit/' + data.id,
    method: 'post',
    data
  })
};
//编辑提交
export const editSubmit = data => {
  return service({
    url: modName + 'editSubmit',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/md/soldTo/api/index.js